module.exports = __webpack_public_path__ + "img/service4.3606bb71.png";